import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ContributingEntityInviteDto } from "../../autogen/bff-api";

export const ContributingEntityInviteFacts = ({ invite }: { invite: ContributingEntityInviteDto }) => {
  const { t } = useTranslation();
  return (
    <>
      <Text fontSize="2xl">
        <b>{t("You have been invited to contribute to an offer")}</b>
      </Text>

      <Text fontSize="md" mt="20px">
        {t("{{leadSupplier}} has named {{entity}} as a participant in their offer to {{buyer}}.", {
          leadSupplier: invite.leadSupplierName,
          entity: invite.entityName,
          buyer: invite.buyerOrganizationName,
        })}
      </Text>

      <Box mt="20px" fontSize="sm" color="smMuted">
        <Text>
          <b>{t("Procurement")}:</b> {invite.eventTitle}
          {invite.eventReference ? ` (${invite.eventReference})` : ""}
        </Text>
        <Text>
          <b>{t("Sent to")}:</b> {invite.invitedEmailMasked}
        </Text>
      </Box>

      <Text fontSize="md" mt="20px">
        {t(
          "The regulations require every participating company to submit its own self-declaration (ESPD Part II and III).",
        )}
      </Text>
    </>
  );
};
